import { Button } from "@progress/kendo-react-buttons";
import { Dialog } from "@progress/kendo-react-dialogs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Loader } from "@progress/kendo-react-indicators";
import { useEffect, useState } from 'react';
import { JsonResponse } from "TypeGen/json-response";
import { useTrack } from ".";
import CenterDivPanel from "../../components/CenterDivPanel";
import { fetchApi } from '../../services/api';

type Props = {
  orderId: number;
  onClose: () => void;
}

type ApplicationUser = {
  ID: string;
  Name: string;
}

const AssignOrderPopup = (props: Props) => {
  const track = useTrack();
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState<ApplicationUser[]>([]);
  const [selectedUser, setSelectedUser] = useState('');
  const [assignedToUser, setAssignedToUser] = useState('');
  const [orderNumber, setOrderNumber] = useState(0);

  useEffect(() => {
    fetchApi('/api/User/UsersDropdown')
      .then((data: { Users: ApplicationUser[] }) => {
        setUsers(data.Users);
      });
  }, [setUsers]);

  useEffect(() => {
    fetchApi(`/api/Track/GetAssignOrder/${props.orderId}`)
      .then((response: any) => {
        setSelectedUser(response.UserID ?? "");
        setAssignedToUser(response.UserID ?? "");
        setOrderNumber(response.OrderNumber);
      }).catch((e) => {
        // If not problem details
        if (!e?.status) alert(e);
      });
  }, [props.orderId]);

  const assign = (assignUser: boolean) => {
    setLoading(true);
    const payload = {
      UserID: selectedUser,
      AssignUser: assignUser
    }

    fetchApi(`/api/Track/AssignOrder/${props.orderId}`, payload, 'POST')
      .then((response: JsonResponse) => {
        if (response.Success) {
          setLoading(false);
          track?.refresh();
          props.onClose();
        } else {
          alert(response.ErrorMessage);
        }
      })
      .catch((e) => {
        setLoading(false);
        // If not problem details
        if (!e?.status) alert('Unable to assign.');
      });
  }

  return <>
    <Dialog
      title={`Assign Order ${orderNumber}`}
      onClose={props.onClose}
    >
      {loading && <CenterDivPanel>
        <Loader type="converging-spinner" />
      </CenterDivPanel>}

      <div className="k-form k-form-md p-0">
        <label className="d-flex">
          <DropDownList
            style={{ width: 250 }}
            data={users}
            // label="Assign To"
            defaultItem={{ ID: 0, Name: "Select User" }}
            value={users.find(x => x.ID == selectedUser)}
            textField="Name"
            onChange={(e) => setSelectedUser(e.target.value.ID)}
          />
          &nbsp;
          {assignedToUser === selectedUser && <>&nbsp;&nbsp;<Button type="button" disabled={loading || selectedUser == null} themeColor="error"
            className="align-self-end" onClick={() => assign(false)}>
            Unassign
          </Button></>}

          {assignedToUser !== selectedUser && <>&nbsp;&nbsp;<Button type="button" disabled={loading || selectedUser == null} themeColor="primary" className="align-self-end" onClick={() => assign(true)}>
            Assign
          </Button></>}

          &nbsp;&nbsp;
          <Button type="button" className="align-self-end" onClick={props.onClose}>
            Cancel
          </Button>
        </label>
      </div>
    </Dialog>
  </>

}
export default AssignOrderPopup;